module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "dados"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('dados')
      }
    }
  }, [_vm._v("DADOS DO PRODUTO")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "funcionamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('funcionamento')
      }
    }
  }, [_vm._v("FUNCIONAMENTO")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva == 'dados'),
      expression: "tabAtiva == 'dados'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Codigo Interno (ERP)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigo_interno),
      expression: "codigo_interno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.codigo_interno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigo_interno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descricao),
      expression: "descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "cols": "12"
    },
    domProps: {
      "value": (_vm.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descricao = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.formularioPreco), function(linha, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.preco),
        expression: "linha.preco"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control currency",
      attrs: {
        "value": "0",
        "min": "0",
        "step": "0.01",
        "data-number-to-fixed": "2",
        "data-number-stepfactor": "100"
      },
      domProps: {
        "value": (linha.preco)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "preco", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.id_cardapio),
        expression: "linha.id_cardapio"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(linha, "id_cardapio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.id_cardapio === 0),
        expression: "linha.id_cardapio===0"
      }]
    }, [_vm._v("*Campo Obrigatório")])]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.adicionaPreco
      }
    }, [_vm._v("Adicionar Preço")])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerPreco(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.ativo),
      callback: function($$v) {
        _vm.ativo = $$v
      },
      expression: "ativo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Produtos permite adicionais")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "sync": true
    },
    model: {
      value: (_vm.permiteadicionais),
      callback: function($$v) {
        _vm.permiteadicionais = $$v
      },
      expression: "permiteadicionais"
    }
  })], 1)]), _c('br'), _vm._v(" "), _vm._l((_vm.adicionais), function(catAdicional, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.permiteadicionais),
        expression: "permiteadicionais"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria adicionais")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (catAdicional.categoria),
        expression: "catAdicional.categoria"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(catAdicional, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Quantidade Permitida")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (catAdicional.qtde),
        expression: "catAdicional.qtde"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (catAdicional.qtde)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(catAdicional, "qtde", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Obrigatório")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "sync": true
      },
      model: {
        value: (catAdicional.exigido),
        callback: function($$v) {
          _vm.$set(catAdicional, "exigido", $$v)
        },
        expression: "catAdicional.exigido"
      }
    })], 1), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.addAdicionais
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerAdicional(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabAtiva === 'funcionamento'),
      expression: "tabAtiva === 'funcionamento'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Definir funcionamento")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.possuiFuncionamento),
      callback: function($$v) {
        _vm.possuiFuncionamento = $$v
      },
      expression: "possuiFuncionamento"
    }
  })], 1)]), _c('br'), _c('br'), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.possuiFuncionamento),
      expression: "possuiFuncionamento"
    }],
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.funcionamento), function(linha) {
    return _c('li', [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.ativo),
        expression: "linha.ativo"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(linha.ativo) ? _vm._i(linha.ativo, null) > -1 : (linha.ativo)
      },
      on: {
        "change": function($event) {
          var $$a = linha.ativo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(linha, "ativo", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(linha, "ativo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(linha, "ativo", $$c)
          }
        }
      }
    }), _vm._v("\n                    " + _vm._s(linha.dia.toUpperCase()) + "\n                  ")])]), _vm._v(" "), _c('ul', {
      attrs: {
        "type": "none"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.ativo),
        expression: "linha.ativo"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_1),
        expression: "linha.hr_abertura_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_1", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_1),
        expression: "linha.hr_fechamento_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_1", $event.target.value)
        }
      }
    }), _vm._v("    -   "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_2),
        expression: "linha.hr_abertura_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_2", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_2),
        expression: "linha.hr_fechamento_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_2", $event.target.value)
        }
      }
    })])])])
  }), 0)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6539ea9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/NovoProduto.vue
// module id = 1259
// module chunks = 1